import {
  TabView as BaseTabView,
  TabDefinition,
} from '@features/campaigns/components/TabView';
import { SummaryContainer } from './Summary/SummaryContainer';
import { PerformanceByRetailerContainer } from './PerformanceByRetailer/PerformanceByRetailerContainer';
import { RealTimeOptimizationContainer } from './RealTimeOptimization/RealTimeOptimizationContainer';
import { LabelWithBadge } from '@components/shared/LabelWithBadge';

const tabs: TabDefinition[] = [
  {
    label: 'Campaign Summary',
    component: <SummaryContainer />,
    path: 'summary',
  },
  {
    label: 'Real-Time Optimization',
    component: <RealTimeOptimizationContainer />,
    path: 'real-time-optimization',
  },
  {
    label: <LabelWithBadge label="Performance by Retailer" badge="Trial" />,
    component: <PerformanceByRetailerContainer />,
    path: 'performance-by-retailer',
  },
];

export const TabView = () => {
  return <BaseTabView tabs={tabs} />;
};
